import { render, staticRenderFns } from "./downtabsClient.vue?vue&type=template&id=2efc741c&scoped=true&"
import script from "./downtabsClient.vue?vue&type=script&lang=js&"
export * from "./downtabsClient.vue?vue&type=script&lang=js&"
import style0 from "./downtabsClient.vue?vue&type=style&index=0&id=2efc741c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2efc741c",
  null
  
)

export default component.exports